/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

 import '@material/layout-grid/mdc-layout-grid.scss';
 import './index.scss';

 class LayoutGrid extends Component {
 	constructor(props){
 		super(props);
 		this.state = {

 		};
 	}
 	render({
 		'class': className,
 		children,
    white,
 		...props
 	}){
 		const classes = classnames('mdc-layout-grid',
    {
      'mdc-layout-grid__white': white
 		}, className);

 		return(
 			<div class={classes}>
 				{children}
 			</div>
 			);
 		} // end of render function
}

class LayoutGridInner extends Component {
	constructor(props){
		super(props);
		this.state = {

		};
	}
	render({
		'class': className,
		children,
 		...props
	}){
		const classes = classnames('mdc-layout-grid__inner', {}, className);

		return(
			<div class={classes}>
				{children}
			</div>
		);
	}
}

class LayoutGridCell extends Component {
	constructor(props){
		super(props);
		this._propsDict = {
		      cols: "cols",
		      desktop: "desktopCols",
		      tablet: "tabletCols",
		      phone: "phoneCols",
		      order: "order",
		      align: "align"
		    };
	}

	createClassName(props) {
	    const baseClass = "mdc-layout-grid__cell mdc-layout-grid__cell--";
	    const classes = [];

	    if (props[this._propsDict.cols]) {
	      classes.push(baseClass + "span-" + props[this._propsDict.cols]);
	    }

	    if (props[this._propsDict.desktop]) {
	      classes.push(
	        baseClass + "span-" + props[this._propsDict.desktop] + "-desktop"
	      );
	    }

	    if (props[this._propsDict.tablet]) {
	      classes.push(
	        baseClass + "span-" + props[this._propsDict.tablet] + "-tablet"
	      );
	    }

	    if (props[this._propsDict.phone]) {
	      classes.push(
	        baseClass + "span-" + props[this._propsDict.phone] + "-phone"
	      );
	    }

	    if (props[this._propsDict.order]) {
	      classes.push(baseClass + "order-" + props[this._propsDict.order]);
	    }

	    if (props[this._propsDict.align]) {
	      classes.push(baseClass + "align-" + props[this._propsDict.align]);
	    }

	    if (props.className) {
	      classes.push(props.className);
	    }

	    return classes.join(" ");
	  }
	render(props){
		return(
			<div className={this.createClassName(props)}>
				{props.children}
			</div>
		);
	}
}

LayoutGrid.Inner = LayoutGridInner;
LayoutGrid.Cell = LayoutGridCell;

export default LayoutGrid;



// WEBPACK FOOTER //
// ../q-mdc/elements/material-layout-grid/index.js